import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@sib/auth';
import { Layout, UIContextProvider } from '@sidecar/common/components';
import { paths } from '@sidecar/config/paths';
import { routes as authRoutes } from './auth';
import { routes as dashboardRoutes } from './dashboard';
import { routes as projectRoutes } from './projects';

export const routes: RouteObject[] = [
  ...authRoutes,
  // All unprotected routes go above this line
  {
    element: (
      <ProtectedRoute fallbackPath={paths.login}>
        <UIContextProvider>
          <Layout>
            <Outlet />
          </Layout>
        </UIContextProvider>
      </ProtectedRoute>
    ),
    // All protected routes go inside array below
    children: [
      ...dashboardRoutes,
      ...projectRoutes,
      {
        path: paths.any,
        index: true,
        element: <Navigate to={paths.dashboard} replace />,
      },
    ],
  },
];
